import { FunctionComponent, ReactNode } from 'react'
import styled, { css } from 'styled-components'

interface LabelProps {
  labelColor: string | undefined
  children: ReactNode
}

type StyledLabelProps = Pick<LabelProps, 'labelColor'>

const StyledLabel = styled.div<StyledLabelProps>`
  ${({
    labelColor,
    theme: {
      typography: {
        catchword: {
          small2: { bundledCSS: catchwordSmall2 },
        },
      },
      spacing: { spacing4 },
      colors: { staticWhite, fillBrand },
      utils: { ellipsis },
    },
  }) => css`
    ${catchwordSmall2};
    color: ${staticWhite};
    text-transform: uppercase;
    margin-bottom: ${spacing4};
    padding: 0.28em 0.4em 0.2em;
    background-color: ${labelColor ?? fillBrand};
    ${ellipsis('100%', 1)};
    display: inline-block;

    &:empty {
      background-color: transparent;
      padding-left: 0;
      padding-right: 0;

      &:before {
        content: '​';
        width: 0;
      }
    }
  `}
`

const Label: FunctionComponent<LabelProps> = ({ labelColor, children }) => {
  return <StyledLabel labelColor={labelColor}>{children}</StyledLabel>
}

export default Label
